import * as React from 'react'

import { Fields } from 'embed/constants/fields'
import { Product } from 'even-ts-static'

import { StepTitle } from 'embed/components/Application/StepTitle'
import { ApplicationField } from 'embed/components/ApplicationField/container'

import Wrapper from '../Wrapper'

export interface Props {
  directReferral: boolean
  dispatchBackToStepOne: () => void
  onBack: () => void
  onContinue: () => void
  stepByStepApplicationStepIsValid: boolean
  currentStep: number
  totalNumberOfSteps: number
}

export const StepbystepApplicationStepLicensePlateInfo: React.FC<Props> = (props) => (
  <Wrapper {...props}>
    <StepTitle>What's your license plate information?</StepTitle>
    <ApplicationField product={Product.Loan} field={Fields.LicensePlateNumber} />
    <ApplicationField product={Product.Loan} field={Fields.LicensePlateState} />
  </Wrapper>
)
